import {keyMirror} from 'utils/DBUtils';

export const Types = keyMirror({
  OPEN_MODAL: null,
  CLOSE_MODAL: null
});

export const openModal = () => ({
  type: Types.OPEN_MODAL
});

export const closeModal = () => ({
  type: Types.CLOSE_MODAL
});



// WEBPACK FOOTER //
// ./public/components/DateRange/actions.js